<atn-ds-section name="Rules">
  <atn-ds-table [config]="tableConfig" />
</atn-ds-section>
